<div class="table-container">
  <app-inventory-table-functions
    [hasActiveFilters]="hasActiveFilters()"
    [activeFilters]="activeFilters()"
    (openFilterDrawer)="openFilterDrawer()"
    (searchEvent)="onSearch($event)"
    (filtersReseted)="onFilterReset()"
    (filterRemoved)="removeFilter($event)"
  />
  <div class="table-container__table table">
    <div class="table__items inventory-items">
      <div class="inventory-items__headings">
        <ul>
          @for (column of columns; track column) {
            <li>
              <span class="text">{{ column.label | translate }}</span>
              @if (column.sortable) {
                <button class="icon" (click)="sortByColumn(column.key)">
                  <app-icon [icon]="iconName.TRAFFICARROW" />
                </button>
              }
            </li>
          }
        </ul>
      </div>
      <div class="inventory-items__contents">
        @let loading = isLoading();
        @let items = inventoryItems();

        @if (loading) {
          <div class="loading-overlay">
            <mat-progress-spinner mode="indeterminate" diameter="40" />
          </div>
        }

        @if (items.length > 0) {
          @for (item of items; track item.id; let i = $index) {
            <div [appAlternatingRow]="i">
              <app-inventory-item
                (openModal)="openViewItem($event)"
                (openEditModal)="openEditItem($event)"
                [inventoryItem]="item"
              />
            </div>
          }
        }

        @if (isSearchEmpty()) {
          <div class="no-search-items">
            <app-icon class="no-search-items__icon" [icon]="iconName.EMPRY_INVENTORY" />
            <span class="no-search-items__message">
              {{ 'inventory.messages.noItemsWithSearch' | translate }}
            </span>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="footer">
    @if (showPagination()) {
      <app-table-pagination
        [pagination]="inventoriesPagination()"
        (pageChange)="handlePageChange($event)"
        (pageSizeChange)="handlePageSizeChange($event)"
      />
    }
  </div>
  <app-inventory-filter-drawer
    (filterApplied)="onFilterApplied($event)"
    (filterReset)="onFilterReset()"
  />
</div>
